(() => {
  const menuToggles = document.querySelectorAll('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuBackdrop = document.querySelector('[data-menu-backdrop]');
  const header = document.querySelector('[data-header]');

  if (header) {
    let ticking = false;
    let isCompact = false;

    const updateHeaderState = () => {
      ticking = false;
      const y = window.scrollY || 0;
      const shouldCompact = isCompact ? y > 28 : y > 72;
      const shouldFloat = shouldCompact && window.matchMedia('(min-width: 991px)').matches;
      isCompact = shouldCompact;

      header.classList.toggle('is-brand-focus', !shouldCompact);
      header.classList.toggle('is-compact', shouldCompact);
      header.classList.toggle('is-floating', shouldFloat);
      document.body.classList.toggle('has-floating-header', shouldFloat);
      document.documentElement.style.setProperty('--floating-header-space', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    };

    const requestHeaderState = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateHeaderState);
    };

    window.addEventListener('scroll', requestHeaderState, { passive: true });
    window.addEventListener('resize', requestHeaderState);
    requestHeaderState();
  }

  if (menuToggles.length && mobileMenu) {
    menuToggles.forEach((menuToggle) => menuToggle.addEventListener('click', () => {
      const willOpen = !mobileMenu.classList.contains('is-open');
      mobileMenu.classList.toggle('is-open', willOpen);
      mobileMenu.setAttribute('aria-hidden', String(!willOpen));
      if (menuBackdrop) {
        menuBackdrop.classList.toggle('is-open', willOpen);
        menuBackdrop.setAttribute('aria-hidden', String(!willOpen));
      }
      document.body.classList.toggle('menu-open', willOpen);
      menuToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(willOpen)));
    }));
  }

  const backToTop = document.querySelector('[data-back-to-top]');
  if (backToTop) {
    const updateBackToTop = () => {
      backToTop.classList.toggle('is-visible', window.scrollY > 520);
    };

    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    window.addEventListener('scroll', updateBackToTop, { passive: true });
    updateBackToTop();
  }

  const initSlider = (slider) => {
    if (slider.dataset.sliderReady === 'true') return;

    const section = slider.closest('.featured-products');
    const controlsRoot = section || slider.closest('.silso-section');
    const prev = controlsRoot && controlsRoot.querySelector('[data-slider-prev]');
    const next = controlsRoot && controlsRoot.querySelector('[data-slider-next]');
    const step = () => Math.max(280, Math.round(slider.clientWidth * 0.72));

    if (prev) {
      prev.addEventListener('click', () => slider.scrollBy({ left: -step(), behavior: 'smooth' }));
    }
    if (next) {
      next.addEventListener('click', () => slider.scrollBy({ left: step(), behavior: 'smooth' }));
    }

    slider.dataset.sliderReady = 'true';
  };

  document.querySelectorAll('[data-slider]').forEach(initSlider);

  const initCart = () => {
    const cartForm = document.querySelector('[data-cart-form]');
    if (!cartForm) return;

    const currency = cartForm.dataset.currency || 'USD';
    const subtotal = cartForm.querySelector('[data-cart-subtotal]');
    const cartBadge = document.querySelector('.site-header__cart span');

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency,
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `${currency} ${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    };

    const setLineBusy = (line, busy) => {
      line.classList.toggle('is-updating', busy);
      line.setAttribute('aria-busy', String(busy));
      line.querySelectorAll('button, input, a').forEach((control) => {
        if (control.matches('[data-cart-remove]')) {
          if (busy) control.setAttribute('aria-disabled', 'true');
          else control.removeAttribute('aria-disabled');
          return;
        }
        control.toggleAttribute('disabled', busy);
      });
    };

    const syncCartView = (cart, line, quantity) => {
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      if (cartBadge) cartBadge.textContent = String(cart.item_count);

      if (quantity === 0) {
        line.remove();
        window.location.reload();
        return;
      }

      const lineIndex = Number(line.dataset.lineIndex) || 1;
      const item = cart.items[lineIndex - 1];
      const linePrice = line.querySelector('[data-cart-line-price]');
      if (item && linePrice) linePrice.textContent = formatMoney(item.final_line_price);
    };

    const updateLine = async (line, quantity) => {
      const safeQuantity = Math.max(0, Number(quantity) || 0);
      const input = line.querySelector('[data-cart-qty]');
      const lineIndex = Number(line.dataset.lineIndex);
      if (!lineIndex || !input) return;

      input.value = String(safeQuantity);
      setLineBusy(line, true);

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ line: lineIndex, quantity: safeQuantity }),
        });

        if (!response.ok) throw new Error('Cart update failed');
        const cart = await response.json();
        syncCartView(cart, line, safeQuantity);
      } catch (error) {
        window.location.reload();
      } finally {
        if (line.isConnected) setLineBusy(line, false);
      }
    };

    cartForm.querySelectorAll('[data-cart-line]').forEach((line) => {
      const input = line.querySelector('[data-cart-qty]');
      const minus = line.querySelector('[data-cart-qty-minus]');
      const plus = line.querySelector('[data-cart-qty-plus]');
      const remove = line.querySelector('[data-cart-remove]');
      if (!input || !minus || !plus) return;

      minus.addEventListener('click', () => updateLine(line, Number(input.value) - 1));
      plus.addEventListener('click', () => updateLine(line, Number(input.value) + 1));
      input.addEventListener('change', () => updateLine(line, input.value));

      if (remove) {
        remove.addEventListener('click', (event) => {
          event.preventDefault();
          if (remove.getAttribute('aria-disabled') === 'true') return;
          updateLine(line, 0);
        });
      }
    });
  };

  initCart();

  function resolveHeroImageUrl(path, fallbackUrl) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path) || path.startsWith('//') || path.startsWith('/')) return path;

    try {
      const fallback = new URL(fallbackUrl, window.location.href);
      fallback.pathname = fallback.pathname.replace(/\/[^/]*$/, `/${encodeURIComponent(path)}`);
      fallback.search = '';
      return fallback.toString();
    } catch (error) {
      return path;
    }
  }

  document.querySelectorAll('[data-dynamic-hero]').forEach((hero) => {
    const layers = Array.from(hero.querySelectorAll('[data-hero-bg-layer]'));
    const heading = hero.querySelector('[data-hero-heading]');
    const subheading = hero.querySelector('[data-hero-subheading]');
    const buttonLabel = hero.querySelector('[data-hero-button-label]');
    const fallbackUrl = hero.dataset.heroFallback;
    const jsonUrl = hero.dataset.heroBgsUrl;
    const interval = Number(hero.dataset.heroInterval || 8000);
    let activeLayer = 0;
    let activeImage = 0;

    if (!layers.length || !fallbackUrl) return;

    const setBackground = (url, shouldSwap = false) => {
      if (!url) return;
      const nextLayer = shouldSwap ? (activeLayer + 1) % layers.length : activeLayer;
      layers[nextLayer].style.backgroundImage = `url("${url}")`;

      if (shouldSwap) {
        layers[activeLayer].classList.remove('is-active');
        layers[nextLayer].classList.add('is-active');
        activeLayer = nextLayer;
      } else {
        layers[activeLayer].classList.add('is-active');
      }
    };

    const setCopy = (entry) => {
      if (!entry || typeof entry !== 'object') return;
      if (heading && entry.heading) heading.textContent = entry.heading;
      if (subheading && entry.subheading) subheading.textContent = entry.subheading;
      if (buttonLabel && (entry.button || entry.button_label)) buttonLabel.textContent = entry.button || entry.button_label;
    };

    const preload = (url) => new Promise((resolve) => {
      const image = new Image();
      image.onload = () => resolve(url);
      image.onerror = () => resolve('');
      image.src = url;
    });

    setBackground(fallbackUrl);

    if (!jsonUrl) return;

    fetch(jsonUrl)
      .then((response) => (response.ok ? response.json() : []))
      .then((payload) => {
        const entries = Array.isArray(payload) ? payload : payload.images;
        const slides = (Array.isArray(entries) ? entries : [])
          .map((entry) => (typeof entry === 'string' ? { src: entry } : entry))
          .filter((entry) => entry && entry.src)
          .map((entry) => ({ ...entry, src: resolveHeroImageUrl(entry.src, fallbackUrl) }))
          .filter((entry) => entry.src);

        if (!slides.length) return;

        activeImage = Math.floor(Math.random() * slides.length);
        setCopy(slides[activeImage]);
        preload(slides[activeImage].src).then((url) => {
          if (url) setBackground(url, true);
        });

        if (slides.length < 2) return;

        window.setInterval(() => {
          activeImage = (activeImage + 1) % slides.length;
          setCopy(slides[activeImage]);
          preload(slides[activeImage].src).then((url) => {
            if (url) setBackground(url, true);
          });
        }, Math.max(interval, 6000));
      })
      .catch(() => {});
  });

  document.querySelectorAll('[data-product-recommendations]').forEach((element) => {
    if (!element.dataset.url || element.dataset.loaded === 'true') return;

    fetch(element.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector(`[data-section-id="${element.dataset.sectionId}"]`);

        if (!recommendations || recommendations.innerHTML.trim() === '') return;

        element.innerHTML = recommendations.innerHTML;
        element.dataset.loaded = 'true';
        element.querySelectorAll('[data-slider]').forEach(initSlider);
      })
      .catch(() => {});
  });

  document.querySelectorAll('form[action*="/localization"] select').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (form) form.submit();
    });
  });

  document.querySelectorAll('[data-property-group] input').forEach((input) => {
    input.addEventListener('change', (event) => {
      const panel = event.target.closest('[data-tryon]');
      if (!panel) return;
      panel.dataset.tone = event.target.value.toLowerCase();
    });
  });
})();
